import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';
import 'jquery';
import 'cookieconsent';
import './jquery.privacyIframe.js';
import './init.js';

require('cookieconsent/build/cookieconsent.min.css')
import '../scss/base.scss';